import React, {useLayoutEffect, useState} from "react";
import axios from "axios";
import EhrazWaiting from "./EhrazWaiting";
import Ehraz from "./Ehraz";
import MangeDashboard from "./MangeDashboard";
import Loading from "../login/Loading";
import EhrazAccept from "./EhrazAccept";
import EhrazReject from "./EhrazReject";
import { toast } from "react-toastify";
import FastAuthentication from "./FastAuthentication";
import CheckLevelEhraz from "./CheckLevelEhraz";

const BASEURL = 'https://api.siantether.com/Auth/Ehraz/';

export default function ManageEhraz (){

    const [ehraz,setehraz] = useState('')
    const [message,setmessage] = useState('')
    const[Level,setLevel] = useState('')




    useLayoutEffect(() => {
        function fetchData() {
        
         // You can await here
         const response =  axios.get('https://api.sinatether.com/Auth/Ehraz/',{
           withCredentials:true
       }).then((res)=>{
           if (res.status == 200){
               


            setehraz(res.data['state'])
            setLevel(res.data['level'])
            setmessage(res.data['message'])





           }
       }).catch((error)=>{
           if (error){
               toast.error("مشکلی پیش امده است مجددا تلاش فرمایید")
           }
       })
   }
         // ...
       
       fetchData();


    }, [])

    function renderElement(){
                if(ehraz == 'accept')
                {
                    return <EhrazAccept/>

                }
                if (ehraz == 'waiting'){
                    return <EhrazWaiting/>
                }
                if (ehraz == 'NotSending'){
                    if (Level == 'first_verified'){
                        return <CheckLevelEhraz/>
                    }else{
                        return <FastAuthentication/>


                    }
                }
                if (ehraz == 'reject'){
                    return <EhrazReject message={message} level={Level}/>
                }



                return <MangeDashboard><Loading/></MangeDashboard>

        }




    return(

        <>
                {renderElement()}


        </>

    )
}